import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["leftScrollButton", "rightScrollButton", "tabs"];

  connect() {
    this.toggleScrollButtons();
  }

  scrollRight() {
    this.tabsTarget.scrollBy({
      left: this.element.clientWidth,
      behavior: "instant"
    });
    this.toggleScrollButtons();
  }

  scrollLeft() {
    this.tabsTarget.scrollBy({
      left: -this.element.clientWidth,
      behavior: "instant",
    });
    this.toggleScrollButtons();
  }

  toggleScrollButtons() {
    this.rightScrollButtonTarget.classList.toggle("hidden", this.tabsTarget.scrollLeft === this.tabsTarget.scrollWidth - this.tabsTarget.clientWidth);
    this.leftScrollButtonTarget.classList.toggle("hidden", this.tabsTarget.scrollLeft === 0);
  }
}
